import { MouseEvent, ReactNode, useEffect, useState } from 'react';

interface ITooltip {
    $button: ReactNode,
    children: ReactNode,
    width: string,
}

/**
 * Tooltip Widget
 */
const Tooltip = (props: ITooltip) => {
    const [isVisible, setIsVisible] = useState(false);

    const stopPropagation = (evt: MouseEvent) => {
        evt.stopPropagation();
        evt.preventDefault();
    };

    /**
     * on button click ---> open tooltip
     */
    const handleButtonClick = (evt: MouseEvent) => {
        evt.stopPropagation();
        evt.preventDefault();
        setIsVisible(true);
    };

    /**
     * perform tooltip close on outside click
     */
    useEffect(() => {
        const handleClick = () => {
            setIsVisible(false);
        };

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);

    return (
        <div className="relative" onMouseDown={ stopPropagation } onClick={ stopPropagation }>
            {
                <div onMouseDown={ handleButtonClick }>
                    { props.$button }
                </div>
            }
            {
                isVisible &&
                <div
                    className="text-sm bg-gray-600 text-white p-3 text-center absolute pointer"
                    style={{
                        width: props.width
                    }}
                >
                    { props.children }
                </div>
            }
        </div>
    )
};

export default Tooltip;